import { render, staticRenderFns } from "./ReasonCard.vue?vue&type=template&id=2f258b57&scoped=true"
import script from "./ReasonCard.vue?vue&type=script&lang=js"
export * from "./ReasonCard.vue?vue&type=script&lang=js"
import style0 from "./ReasonCard.vue?vue&type=style&index=0&id=2f258b57&prod&lang=scss&scoped=true"
import style1 from "./ReasonCard.vue?vue&type=style&index=1&id=2f258b57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f258b57",
  null
  
)

export default component.exports